export default __webpack_public_path__ + "static/media/pd2.461854f0.jpg";